import DateFnsUtils from '@date-io/date-fns'
import { yupResolver } from '@hookform/resolvers'
import CardContents from '@ifca-root/react-component/src/components/CardList/CardContents'
import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader'
import { ItemVoiceTextField } from '@ifca-root/react-component/src/components/Input/CustomItemTextField'
import { VoiceTextField } from '@ifca-root/react-component/src/components/Input/CustomTextField'
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper'
import Loading from '@ifca-root/react-component/src/components/Loading/Loading'
import {
  CircularProgress,
  Grid,
  ListSubheader,
  MenuItem,
  Paper,
  TextField,
  Typography,
} from '@material-ui/core'
import { Autocomplete } from '@material-ui/lab'
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers'
import { AccountClient } from 'AccountClient'
import { ErrorDialog } from 'components/Dialog/ErrorDialog'
import { ExitConfirmationDialog } from 'components/Dialog/ExitConfirmationDialog'
import { AccCodeDropdownFullWidth } from 'components/Dropdown/AccCodeDropdown'
import { AccountFooter } from 'components/Footer/AccountFooter'
import { TaxExemptionCalculationData } from 'containers/APModule/components/ItemDialog'
import { getDocAmt } from 'containers/CashBookModule/Receipt/receipt'
import { DefaultDepartmentHandlerService } from 'containers/GeneralLedgerModule/Hooks/DefaultDepartment/DefaultDepartmentService'
import {
  AccountType,
  CommonStatus,
  useGetCompanyNameQuery,
  useGetDepartmentListingByCoaLazyQuery,
  useGetMasterCoaForFormQuery,
  useGetTaxExemptionCalculationLazyQuery,
  useGetTaxSchemeNewListingQuery,
} from 'generated/graphql'
import { calculateTaxDetail } from 'helpers/Calculation/taxCalculationDetail'
import { filterTaxSchemeEffectiveDate } from 'helpers/Filter/filterTaxSchemeEffectiveDate'
import { SystemMsgs } from 'helpers/Messages/SystemMsg'
import { formatDashDate } from 'helpers/StringNumberFunction/FormatDate'
import { amtNumStr, amtStr } from 'helpers/StringNumberFunction/NumFormatters'
import React, { useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import NumberFormat from 'react-number-format'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import { uuid } from 'uuidv4'
import * as yup from 'yup'
import '../Payment.scss'

interface PaymentItemProps {
  DocDate: string
  MasterCOAID: string
  Amount: number
  TaxSchemeID: string
  TaxAmt: number
  DocAmt: number
  CostCentreID: string
  Remark: string
  DocNo: string
  TaxAmtDetail: any
  TaxExemptionReason: string
  TaxExemptionAmount: number
  TaxExemptionRate: number
}

const defaultVal: any = {
  DocDate: null,
  MasterCOAID: '',
  Amount: '',
  TaxSchemeID: '',
  TaxAmt: 0,
  DocAmt: 0,
  CostCentreID: undefined,
  Remark: '',
  DocNo: '',
  TaxExemptionReason: '',
  TaxExemptionAmount: 0,
  TaxExemptionRate: 0,
}

export const PaymentItemForm = (props: any) => {
  const {
    CompanyID,
    BankAccountID,
    PaymentID,
    PaymentItemID,
    formMode,
    detailMode,
  }: any = useParams()

  let form, mode
  switch (detailMode) {
    case 'add':
      form = 'New'
      mode = 'add'
      break
    case 'edit':
      form = 'Edit'
      mode = 'edit'
  }

  let history = useHistory()
  let location = useLocation()
  const editData = location?.state as any
  const itemEditData: any = JSON.parse(
    localStorage.getItem('paymentItem')
  )?.filter(item => item?.PaymentItemID === PaymentItemID)[0]

  /* -------------------------------------------- */
  /*                    STATE                     */
  /* -------------------------------------------- */
  const [cost, setCost] = useState(0)
  const [selectedTax, setSelectedTax] = useState(null)
  const [openExitConf, setOpenExitConf] = useState(null)
  const [record, setRecord] = useState(false)
  const paymentHeader = JSON.parse(localStorage.getItem('payment'))
  const user = JSON.parse(localStorage.getItem('loggedInUser'))
  const pmtdetail = JSON.parse(localStorage.getItem('paymentItem'))
  const [errorDia, setErrorDia] = useState<boolean>(false)
  const [errMsg, setErrMsg] = useState<string>('')
  const [mountDefVal, setMountDefVal] = useState(!!itemEditData)
  const [voiceRemark, setVoiceRemark] = useState('')
  const [useDefaultDept, setUseDefaultDept] = useState(false)
  const [exemptionVoiceReason, setExemptionVoiceReason] = useState('')
  const [exemptionRecord, setExemptionRecord] = useState(false)

  const [allowValueChange, setAllowValueChange] = useState<boolean>(
    !itemEditData
  )

  const [showExemptedFields, setShowExemptedFields] = useState<boolean>(
    !!itemEditData?.TaxExemptionReason
  )

  /* -------------------------------------------- */
  /*                    USE FORM                     */
  /* -------------------------------------------- */
  // const PaymentItemFormSchema = yup.object().shape({
  //   MasterCOAID: CommonYupValidation.requireField('Account Code is required'),
  //   CostCentreID: CommonYupValidation.requireField(SystemMsgs.costCentre()),
  //   TaxSchemeID: CommonYupValidation.requireField('Tax Code is required'),
  //   Remark: CommonYupValidation.requireField('Remark is required'),
  //   Amount: CommonYupValidation.requireField('Amount is required'),
  //   ...(!!showExemptedFields
  //     ? {
  //         TaxExemptionReason: CommonYupValidation.requireField(
  //           SystemMsgs.taxExemptionReason()
  //         ),
  //       }
  //     : null),
  // })
  const PaymentItemFormSchema = yup.object().shape({
    MasterCOAID: yup
      .string()
      .transform(value => value ?? '')
      .trim()
      .required('Account Code is required'),

    CostCentreID: yup
      .string()
      .transform(value => value ?? '')
      .trim()
      .required(SystemMsgs.costCentre()),

    TaxSchemeID: yup
      .string()
      .transform(value => value ?? '')
      .trim()
      .required('Tax Code is required'),

    Remark: yup
      .string()
      .transform(value => value ?? '')
      .trim()
      .required('Remark is required'),

    Amount: yup
      .number()
      .transform((value, originalValue) => {
        if (typeof originalValue === 'string') {
          const cleanedString = originalValue.replace(/,/g, '')

          if (cleanedString === '') {
            return undefined
          }

          return parseFloat(cleanedString)
        }
        return value
      })
      .moreThan(0.0, 'Amount cannot less than 0.01')
      .typeError('Amount is required')
      .required('Amount is required'),

    ...(!!showExemptedFields
      ? {
          TaxExemptionReason: yup
            .string()
            .transform(value => value ?? '')
            .trim()
            .required(SystemMsgs.taxExemptionReason()),
        }
      : {}),
  })

  const {
    handleSubmit,
    register,
    setValue,
    control,
    errors,
    reset,
    watch,
  } = useForm<PaymentItemProps>({
    defaultValues: {
      DocNo: PaymentItemID && itemEditData ? itemEditData?.DocNo : '',
      DocDate: PaymentItemID && itemEditData ? itemEditData?.DocDate : null,
      MasterCOAID:
        PaymentItemID && itemEditData ? itemEditData?.MasterCOAID : '',
      TaxSchemeID:
        PaymentItemID && itemEditData ? itemEditData?.TaxSchemeID : '',
      TaxAmt: PaymentItemID && itemEditData ? itemEditData?.TaxAmt : 0,
      DocAmt: PaymentItemID && itemEditData ? itemEditData?.DocAmt : 0,
      Remark: PaymentItemID && itemEditData ? itemEditData?.Remark : '',
    },
    mode: 'onSubmit',
    resolver: yupResolver(PaymentItemFormSchema),
  })

  const handleReset = () => {
    setCost(0)
    setSelectedTax(null)
    setValue('CostCentreID', undefined)
  }

  const {
    loading: CompanyLoading,
    data: { getCompany: curCompany } = { getCompany: [] },
  } = useGetCompanyNameQuery({
    fetchPolicy: 'network-only',
    variables: { CompanyID },
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMsg(error)
      setErrDialog(true)
    },
    onCompleted: ({ getCompany }) => {
      setUseDefaultDept(
        getCompany[0]?.GLCompanyPolicy?.DefaultDepartmentBalanceSheetCOA
      )
    },
  })

  // Tax
  const {
    loading: TaxLoading,
    data: { getTaxSchemeListing } = {
      getTaxSchemeListing: [],
    },
  } = useGetTaxSchemeNewListingQuery({
    fetchPolicy: 'network-only',
    client: AccountClient,
    variables: { CommonStatus: CommonStatus.Active, TaxClass: 'INPUT' },
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMsg(error)
      setErrDialog(true)
    },
    onCompleted: ({ getTaxSchemeListing }) => {
      if (mode === 'edit') {
        const filteredTaxScheme = filterTaxSchemeEffectiveDate(
          docDate,
          getTaxSchemeListing
        )

        const selected = filteredTaxScheme.find(
          tax => tax.id === itemEditData.TaxSchemeID
        )
        setSelectedTax(selected)

        initializeTaxDetailsInEditMode(selected)

        let recalculateCost =
          selected?.isExclusive === true
            ? itemEditData?.DocAmt - itemEditData?.TaxAmt
            : itemEditData?.DocAmt

        setCost(recalculateCost)
        setValue('Amount', recalculateCost)
      }
    },
  })

  const {
    loading: MasterCOALoading,
    data: { getMasterCOAForForm } = { getMasterCOAForForm: [] },
  } = useGetMasterCoaForFormQuery({
    fetchPolicy: 'network-only',
    variables: { CompanyID },
    onCompleted: ({ getMasterCOAForForm }) => {
      if (itemEditData?.MasterCOAID) {
        let accountType = getMasterCOAForForm?.find(
          x => x?.MasterCOAID === itemEditData?.MasterCOAID
        )?.AccountType

        fetchDepartmentListingByCOA({
          variables: {
            CompanyID,
            MasterCOAID: itemEditData?.MasterCOAID,
            AccountType: accountType,
          },
        })
      }
    },
  })

  /* -------------------------------------------- */
  /*                   DEF DEPT                   */
  /* -------------------------------------------- */
  const [
    fetchDepartmentListingByCOA,
    {
      loading: HandlerLoading,
      called: HandlerCalled,
      data: { getDepartmentListingByCOA } = { getDepartmentListingByCOA: [] },
    },
  ] = useGetDepartmentListingByCoaLazyQuery({
    fetchPolicy: 'network-only',
    onCompleted: ({ getDepartmentListingByCOA }) => {
      DefaultDepartmentHandlerService.InitializeDepartmentValueInEditMode({
        DepartmentListingArray: getDepartmentListingByCOA,
        DefaultDepartmentPolicy: useDefaultDept, // nullable; used for GL Department Policy checking
        EditData: itemEditData,
        SetValue: setValue,
        MountDefVal: mountDefVal, // to avoid overriding costcentreid on another api call
        Register: register,
      })
    },
    onError: error => {
      let errorMessage = error.message.substring(15)
      console.log('ERROR', error)
      setErrorDia(true)
      setErrMsg(`${errorMessage}"`)
    },
  })

  const isDefaultChecking: boolean =
    HandlerCalled === true
      ? !!(
          getDepartmentListingByCOA?.length === 1 &&
          !!getDepartmentListingByCOA[0]?.IsDefault
        )
      : false

  const disableDeptController: boolean = !!(
    useDefaultDept === true && isDefaultChecking === true
  )

  /* -------------------------------------------- */
  /*                 EXEMPTED TAX                 */
  /* -------------------------------------------- */
  const [awaitCalc, setAwaitCalc] = useState<boolean>(false)
  const [debounceTimer, setDebounceTimer] = useState(null)
  const [taxExemptionData, setTaxExemptionData] = useState<
    TaxExemptionCalculationData
  >({
    TaxExemptionRate: itemEditData?.TaxExemptionRate ?? null,
    TaxExemptionAmount: itemEditData?.TaxExemptionAmount ?? null,
  })

  const [
    fetchExemptedTaxCalc,
    { loading: ExemptedTaxCalcLoading },
  ] = useGetTaxExemptionCalculationLazyQuery({
    fetchPolicy: 'network-only',
    onError: error => {
      let errorMessage = error.message.substring(15)
      console.log('ERROR', error)
      setErrorDia(true)
      setErrMsg(`${errorMessage}"`)

      setAwaitCalc(false)
    },
    onCompleted: ({ getTaxExemptionCalculation }) => {
      setTaxExemptionData({
        TaxExemptionRate: getTaxExemptionCalculation?.TaxExemptionRate,
        TaxExemptionAmount: getTaxExemptionCalculation?.TaxExemptionAmount,
      })

      setAwaitCalc(false)
    },
  })

  // Debounce method for API based calculation
  const debounceExemptCalc = (
    currTaxSchemeId: string,
    effDate: Date,
    baseAmt: number
  ) => {
    setAwaitCalc(true)
    setTaxExemptionData({ TaxExemptionAmount: null, TaxExemptionRate: null })
    if (debounceTimer) {
      clearTimeout(debounceTimer)
    }

    const newTimer = setTimeout(() => {
      fetchExemptedTaxCalc({
        variables: {
          TaxSchemeID: currTaxSchemeId,
          EffectiveDate: effDate,
          BaseAmount: baseAmt,
        },
      })
    }, 1500)

    setDebounceTimer(newTimer)
  }

  //============================================================================

  // Change Tax descrition into code number
  const [taxAmt, setTaxAmt] = useState(
    !!itemEditData && PaymentItemID ? itemEditData?.TaxAmt : 0
  )

  const docAmt = selectedTax?.isExclusive ? getDocAmt(cost, taxAmt) : cost

  const handleAmtChange = event => {
    setCost(event.value)

    if (selectedTax) {
      prepareTaxCalculationData(selectedTax)
      const taxResult = calculateTaxFromState(selectedTax, event.value)
      setTaxAmt(taxResult?.TaxAmount)
      updateTaxDetailsInForm(taxResult?.taxDetails, taxResult?.TaxAmount)
      setValue(
        'TaxAmt',
        calculateTaxFromState(selectedTax, event.value)?.TaxAmount
      )

      if (selectedTax?.isExemptedTaxScheme === true) {
        debounceExemptCalc(
          selectedTax?.id,
          new Date(docDate),
          Number(event.value)
        )
      }
    }
  }

  const handleTaxAmtChange = event => {
    setTaxAmt(event.value)
  }

  const handleTaxScheme = selected => {
    if (selected) {
      prepareTaxCalculationData(selected)
      setTaxAmt(calculateTaxFromState(selected, watch('Amount'))?.TaxAmount)
      const newResult = calculateTaxFromState(selected, watch('Amount'))
      updateTaxDetailsInForm(newResult?.taxDetails, newResult?.TaxAmount)
      setValue(
        'TaxAmt',
        calculateTaxFromState(selected, watch('Amount'))?.TaxAmount
      )

      // Exempted Tax portion
      setShowExemptedFields(!!selected?.isExemptedTaxScheme)

      if (selected?.isExemptedTaxScheme === true) {
        fetchExemptedTaxCalc({
          variables: {
            TaxSchemeID: selected,
            EffectiveDate: new Date(docDate),
            BaseAmount: Number(cost),
          },
        })
      }
    }
  }

  /* -------------------------------------------- */
  /*                     SUBMIT                   */
  /* -------------------------------------------- */

  const onSubmit = (data, mode, selectedTax, result) => {
    const taxIsExclusive = getTaxSchemeListing?.find(
      x => x?.id === data?.TaxSchemeID
    )?.isExclusive
    const prvdetail =
      detailMode === 'add'
        ? JSON.parse(localStorage.getItem('paymentItem')) || []
        : JSON.parse(localStorage.getItem('paymentItem')).filter(
            x => x?.PaymentItemID !== PaymentItemID
          )
    const formattedTaxDetails = result.taxDetails.map((tax, idx) => {
      return {
        seqNo: tax?.SeqNo,
        taxAmt: watch(`TaxAmtDetail[${idx}]`) ?? tax.TaxAmount,
        taxRate: tax.TaxRate * 100,
        taxCode: tax.taxCode,
        taxId: tax.taxId,
        taxSchemeDetailId: tax.taxSchemeDetailId,
        taxSchemeId: tax.taxSchemeId,
      }
    })
    localStorage.setItem(
      'paymentItem',
      JSON.stringify([
        ...(prvdetail?.length === null || 0 ? null : prvdetail),

        {
          Sequence: itemEditData?.Sequence ?? prvdetail?.length + 1,
          PaymentItemID: detailMode === 'add' ? uuid() : PaymentItemID,
          DocNo:
            formMode === 'add' || formMode === 'edit' || formMode === 'resubmit'
              ? data?.DocNo
              : itemEditData?.DocNo,
          DocDate:
            formMode === 'add' || formMode === 'edit' || formMode === 'resubmit'
              ? data?.DocDate
                ? formatDashDate(new Date(data.DocDate).toISOString())
                : null
              : itemEditData?.DocDate,
          MasterCOAID:
            formMode === 'add' || formMode === 'edit' || formMode === 'resubmit'
              ? data?.MasterCOAID
              : itemEditData?.MasterCOAID,
          ExpenseCode:
            formMode === 'add' || formMode === 'edit' || formMode === 'resubmit'
              ? getMasterCOAForForm.filter(
                  coa => coa?.MasterCOAID === data?.MasterCOAID
                )[0]?.Code
              : getMasterCOAForForm.filter(
                  coa => coa?.MasterCOAID === itemEditData?.MasterCOAID
                )[0]?.Code,
          ExpenseName:
            formMode === 'add' || formMode === 'edit' || formMode === 'resubmit'
              ? getMasterCOAForForm.filter(
                  coa => coa?.MasterCOAID === data?.MasterCOAID
                )[0]?.Name
              : getMasterCOAForForm.filter(
                  coa => coa?.MasterCOAID === itemEditData?.MasterCOAID
                )[0]?.Name,
          Amount:
            formMode === 'add' || formMode === 'edit' || formMode === 'resubmit'
              ? parseFloat(
                  taxIsExclusive === true
                    ? amtNumStr(data?.Amount)
                    : amtNumStr(data?.Amount - data?.TaxAmt)
                )
              : taxIsExclusive === true
              ? itemEditData?.Amount
              : itemEditData?.DocAmt - itemEditData?.TaxAmt,
          TaxSchemeID:
            formMode === 'add' || formMode === 'edit' || formMode === 'resubmit'
              ? data?.TaxSchemeID
              : itemEditData?.TaxSchemeID,
          TaxSchemeName:
            formMode === 'add' || formMode === 'edit' || formMode === 'resubmit'
              ? getTaxSchemeListing.filter(
                  taxcode => taxcode?.id === data?.TaxSchemeID
                )[0]?.name
              : getTaxSchemeListing.filter(
                  taxcode => taxcode?.id === itemEditData?.TaxSchemeID
                )[0]?.name,
          TaxAmt:
            formMode === 'add' || formMode === 'edit' || formMode === 'resubmit'
              ? parseFloat(amtNumStr(data?.TaxAmt))
              : itemEditData?.TaxAmt,
          DocAmt:
            formMode === 'add' || formMode === 'edit' || formMode === 'resubmit'
              ? selectedTax?.isExclusive
                ? getDocAmt(cost, taxAmt)
                : Number(
                    parseFloat(
                      watch('Amount')
                        .toString()
                        .replace(/,/g, '')
                    )
                  )
              : itemEditData?.DocAmt,
          CostCentreID: data?.CostCentreID,
          CostCentreCode: getDepartmentListingByCOA.filter(
            ccc => ccc?.CostCentreID === data?.CostCentreID
          )[0]?.MasterCode,
          Remark: data?.Remark,
          ItemTaxInfo: formattedTaxDetails,
          TaxExemptionReason:
            showExemptedFields && data?.TaxExemptionReason
              ? data?.TaxExemptionReason
              : null,
          TaxExemptionAmount:
            showExemptedFields && taxExemptionData?.TaxExemptionAmount
              ? taxExemptionData?.TaxExemptionAmount
              : null,
          TaxExemptionRate:
            showExemptedFields && taxExemptionData?.TaxExemptionRate
              ? taxExemptionData?.TaxExemptionRate
              : null,
        },
      ])
    )

    if (
      (formMode === 'add' && detailMode === 'add' && mode === 'save') ||
      (formMode === 'add' && detailMode === 'edit' && mode === 'save')
    ) {
      history.push({
        pathname: `/cash-book/${CompanyID}/submenu/${BankAccountID}/payment/${formMode}`,
        state: { ...editData },
      })
    } else if (
      (formMode === 'edit' && detailMode === 'edit' && mode === 'save') ||
      (formMode === 'edit' && detailMode === 'add' && mode === 'save') ||
      formMode === 'approve-reject'
    ) {
      history.push({
        pathname: `/cash-book/${CompanyID}/submenu/${BankAccountID}/payment/${PaymentID}/${formMode}`,
        state: { ...editData, detailMode: 'add' },
      })
    }

    if (mode === 'new' || formMode === 'approve-reject') {
      reset(defaultVal)
    }
  }

  /* -------------------------------------------- */
  /*                TAX CALCULATION               */
  /* -------------------------------------------- */
  const prepareTaxCalculationData = (selectedTax: any) => {
    if (!selectedTax?.taxSchemeDetailList[0]?.taxSchemeDetailItemList?.length) {
      return []
    }

    const taxSchemeDetail = selectedTax?.taxSchemeDetailList[0]

    return taxSchemeDetail.taxSchemeDetailItemList.map(item => ({
      taxId: item.taxId,
      taxSchemeId: taxSchemeDetail.taxSchemeId,
      taxSchemeDetailId: taxSchemeDetail.id,
      seqNo: item.seqNo,
      taxOnSeq: item.taxOnSeq || [],
      computeMethod:
        item.computeMethod === 'TAX_ON_GROSS'
          ? 'Tax_On_Gross'
          : 'Tax_On_Taxed_Price',
      taxRate: item.taxRate,
      taxCode: item.taxInfo?.code,
    }))
  }

  const calculateTaxFromState = (selectedTax: any, amount: number) => {
    const taxData = prepareTaxCalculationData(selectedTax)
    const isExclusive = Boolean(selectedTax?.isExclusive)
    return calculateTaxDetail(taxData, amount, isExclusive)
  }
  let result = calculateTaxFromState(selectedTax, watch('Amount'))

  const docDate = paymentHeader?.DocDate

  const taxSchemeInput = filterTaxSchemeEffectiveDate(
    docDate,
    getTaxSchemeListing
  )

  const initializeTaxDetailsInEditMode = (selectTax: any) => {
    if (itemEditData?.ItemTaxInfo && Array.isArray(itemEditData?.ItemTaxInfo)) {
      itemEditData.ItemTaxInfo.forEach((taxDetail, index) => {
        register(`TaxAmtDetail[${index}]`)
        setValue(
          `TaxAmtDetail[${index}]`,
          taxDetail.taxAmt ?? taxDetail.taxAmount
        )
      })
      setValue('taxDetailsCount', itemEditData.ItemTaxInfo.length)
    } else if (selectTax) {
      const currentAmount = watch('Amount')
      const taxResult = calculateTaxFromState(selectTax, currentAmount)

      if (taxResult?.taxDetails) {
        updateTaxDetailsInForm(taxResult.taxDetails, taxResult.TaxAmount)
      }
    }
  }

  const updateTaxDetailsInForm = (taxDetails, taxAmount) => {
    if (!taxDetails || taxDetails.length === 0) return
    const prevTaxDetailsCount = watch('taxDetailsCount') || 0
    taxDetails.forEach((tax, index) => {
      register(`TaxAmtDetail[${index}]`)
      setValue(`TaxAmtDetail[${index}]`, tax.TaxAmount)
    })
    setValue('taxDetailsCount', taxDetails.length)
    if (prevTaxDetailsCount > taxDetails.length) {
      for (let i = taxDetails.length; i < prevTaxDetailsCount; i++) {
        setValue(`TaxAmtDetail[${i}]`, null)
      }
    }
    setValue('TaxAmt', taxAmount)
    setTaxAmt(taxAmount)
  }

  return (
    <>
      {TaxLoading && <Loading />}
      {CompanyLoading && <Loading />}
      {HandlerLoading && <Loading />}
      {MasterCOALoading && <Loading />}
      {ExemptedTaxCalcLoading && <Loading />}
      <MainHeader
        mainBtn="close"
        onClick={() => {
          if (formMode === 'add')
            history.push({
              pathname: `/cash-book/${CompanyID}/submenu/${BankAccountID}/payment/${formMode}`,
              state: { ...editData },
            })
          else {
            history.push({
              pathname: `/cash-book/${CompanyID}/submenu/${BankAccountID}/payment/${PaymentID}/${formMode}`,
              state: { ...editData, detailMode: 'add' },
            })
          }
          // }
        }}
        smTitle={'Cash Book'}
        title={curCompany[0]?.Name}
        routeSegments={[
          { name: 'Cash Book' },
          { name: 'Cash Book' },
          { name: 'Payment' },
          { name: 'Payment', current: true },
        ]}
        rightRouteSegments={[
          { name: detailMode === 'add' ? 'New' : 'Edit', current: true },
        ]}
      />
      <ContentWrapper float>
        <CardContents section={{ header: { title: 'Payment Detail' } }}>
          <Controller
            as={TextField}
            name="DocNo"
            label="Source Document No."
            margin="dense"
            id="standard-basic"
            InputLabelProps={watch('DocNo') ? { shrink: true } : null}
            autoComplete="off"
            control={control}
            className="left"
            ref={register}
          />

          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <Controller
              as={KeyboardDatePicker}
              name="DocDate"
              label="Source Document Date"
              control={control}
              format="dd/MM/yyyy"
              margin="dense"
              allowKeyboardControl
              onChange={(date: Date | null) => {}}
              ref={register}
              onAccept={date => {}}
              KeyboardButtonProps={{
                'aria-label': 'change date',
              }}
              InputLabelProps={{ shrink: true }}
              showTodayButton
              className="right"
            />
          </MuiPickersUtilsProvider>
          {!MasterCOALoading && (
            <Controller
              render={({ value, onChange }) => {
                //// 'value' is the stored MasterCOAID
                /*
                const defVal = getMasterCOAForForm?.filter(
                  x => x?.MasterCOAID === itemEditData?.MasterCOAID
                )[0]
                */
                //// Set defaultValue as defVal will using defVal instead of value inside Autocomplete
                //// Using selectedAccount will correctly link the display of the component to the value stored in react-hook-form

                //// Find the full object that matches the stored ID
                const selectedAccount =
                  getMasterCOAForForm?.find(x => x?.MasterCOAID === value) ??
                  null

                return (
                  <Autocomplete
                    options={
                      getMasterCOAForForm?.filter(
                        x =>
                          !x?.IsControl &&
                          x?.AccountType !== AccountType.Statistic &&
                          x?.AccountType !== AccountType.MarketSegment
                      ) || []
                    }
                    getOptionLabel={option =>
                      `${option?.Code} | ${option?.Name}`
                    }
                    fullWidth
                    onChange={(value, newValue: any) => {
                      onChange(newValue?.MasterCOAID)
                      setMountDefVal(false)
                      setValue('CostCentreID', null)
                      fetchDepartmentListingByCOA({
                        variables: {
                          CompanyID,
                          MasterCOAID: newValue?.MasterCOAID ?? '',
                          AccountType: newValue?.AccountType ?? '',
                        },
                      })
                    }}
                    // defaultValue={defVal}
                    value={selectedAccount}
                    disabled={mode === 'approve-reject'}
                    PopperComponent={AccCodeDropdownFullWidth}
                    renderOption={(props, option) => {
                      return (
                        <div>
                          <div>
                            <span className="xsTitle">{props?.Code}</span>
                          </div>
                          <div className="desc">{props?.Name}</div>
                        </div>
                      )
                    }}
                    renderInput={(params: any) => {
                      return (
                        <div>
                          <TextField
                            {...params}
                            helperText={errors?.MasterCOAID?.message}
                            error={errors?.MasterCOAID ? true : false}
                            label="Account Code *"
                            style={{ width: '100%' }}
                            disabled={mode === 'approve-reject'}
                            margin="normal"
                            variant="standard"
                          />
                        </div>
                      )
                    }}
                  />
                )
              }}
              label="Account Code "
              name="MasterCOAID"
              autoComplete="off"
              control={control}
              multiline={true}
              fullWidth
              margin="normal"
              ref={register}
              helperText={errors?.MasterCOAID?.message}
              error={errors?.MasterCOAID ? true : false}
              defaultValue={
                getMasterCOAForForm?.filter(
                  x => x?.MasterCOAID === itemEditData?.MasterCOAID
                )[0]?.MasterCOAID
              }
              required
              disabled={formMode === 'approve-reject' ? true : false}
            />
          )}
          <Controller
            render={({ value, onChange }) => {
              const defVal =
                getDepartmentListingByCOA?.find(
                  x => x?.CostCentreID === value
                ) ?? null

              return (
                <Autocomplete
                  options={getDepartmentListingByCOA || []}
                  getOptionLabel={option =>
                    option ? `${option?.MasterCode} | ${option?.Name}` : ''
                  }
                  fullWidth
                  onChange={(value, newValue: any) => {
                    onChange(newValue?.CostCentreID)
                  }}
                  disabled={!!disableDeptController}
                  disableClearable={!!disableDeptController}
                  renderOption={(props, option) => {
                    return (
                      <div>
                        <div>
                          <span className="xsTitle">{props?.MasterCode}</span>
                        </div>
                        <div className="desc">{props?.Name}</div>
                      </div>
                    )
                  }}
                  value={
                    !!disableDeptController
                      ? getDepartmentListingByCOA?.find(
                          cc => cc?.IsDefault === true
                        )
                      : defVal
                  }
                  renderInput={(params: any) => {
                    return (
                      <div>
                        <TextField
                          {...params}
                          helperText={
                            errors?.CostCentreID ? 'Department is required' : ''
                          }
                          error={errors?.CostCentreID ? true : false}
                          label="Department"
                          style={{ width: '100%' }}
                          margin="dense"
                          disabled={!!disableDeptController}
                          required
                        />
                      </div>
                    )
                  }}
                />
              )
            }}
            label="Department"
            name="CostCentreID"
            autoComplete="off"
            control={control}
            multiline={true}
            fullWidth
            margin="dense"
            ref={register}
            helperText={errors?.CostCentreID?.message}
            error={errors?.CostCentreID ? true : false}
            disabled={!!disableDeptController}
            required
          />
          <Controller
            as={<NumberFormat allowNegative={false} />}
            thousandSeparator
            customInput={TextField}
            id="standard-basic"
            name="Amount"
            label="Amount"
            value={cost}
            autoComplete="off"
            control={control}
            onValueChange={e => {
              allowValueChange === true && handleAmtChange(e)
              setAllowValueChange(true)
            }}
            decimalScale={2}
            fixedDecimalScale
            margin="dense"
            required
            helperText={errors?.Amount?.message}
            error={errors?.Amount ? true : false}
            ref={register}
            defaultValue={cost || ''}
          />

          <Controller
            render={({ onChange, onBlur, value }) => {
              const defVal = taxSchemeInput?.filter(
                x => x?.id === watch('TaxSchemeID')
              )[0]
              return (
                <TextField
                  helperText={
                    (watch('TaxSchemeID') === '' ||
                      watch('TaxSchemeID') === undefined) &&
                    errors?.TaxSchemeID?.message
                  }
                  error={
                    (watch('TaxSchemeID') === '' ||
                      watch('TaxSchemeID') === undefined) &&
                    errors?.TaxSchemeID
                      ? true
                      : false
                  }
                  select
                  margin="dense"
                  label="Tax Scheme"
                  required
                  value={value}
                  defaultValue={defVal}
                  SelectProps={
                    !!taxSchemeInput?.filter(
                      x => x?.id === watch('TaxSchemeID')
                    )[0]?.name
                      ? {
                          renderValue: () =>
                            `${selectedTax?.name} | ${
                              selectedTax?.description
                            } ${selectedTax?.isExclusive ? `(E)` : `(I)`}`,
                        }
                      : null
                  }
                  onChange={e => {
                    const selected = taxSchemeInput.find(
                      tax => tax.id === e.target.value
                    )
                    onChange(e)
                    setSelectedTax(selected)
                    handleTaxScheme(selected)
                  }}
                >
                  <ListSubheader>Input</ListSubheader>
                  {taxSchemeInput
                    ?.sort((a, b) => {
                      return a?.name.localeCompare(b?.name)
                    })
                    ?.map((el, index) => (
                      <MenuItem value={el?.id} key={index}>
                        {
                          <div className="content-wrap full">
                            <div>
                              <span className="xsTitle">{el?.name}</span>
                            </div>
                            <div className="desc">
                              {el?.description}{' '}
                              {el?.isExclusive ? `(E)` : `(I)`}
                            </div>
                          </div>
                        }
                      </MenuItem>
                    ))}
                </TextField>
              )
            }}
            select
            name={'TaxSchemeID'}
            margin="dense"
            control={control}
            ref={register}
            autoComplete="off"
            defaultValue={itemEditData?.TaxSchemeID}
            helperText={errors?.TaxSchemeID?.message}
            error={errors?.TaxSchemeID ? true : false}
            disabled={formMode === 'approve-reject' ? true : false}
          />

          {result.taxDetails.length > 0 && (
            <Grid item xs={12}>
              <Paper
                elevation={1}
                style={{
                  padding: '1px 7px',
                  borderRadius: '2px',
                  backgroundColor: '#fff9f2',
                }}
              >
                {result.taxDetails.map((tax, index) => (
                  <Grid container key={index} spacing={1} alignItems="center">
                    <Grid item xs={4}>
                      <Typography
                        variant="body2"
                        style={{
                          fontSize: '0.63rem',
                          fontWeight: 500,
                          lineHeight: '24px',
                          display: 'flex',
                          alignItems: 'center',
                        }}
                      >
                        {tax?.taxCode || `Tax ${index + 1}`}
                      </Typography>
                    </Grid>
                    <Grid item xs={3}>
                      <Typography
                        variant="body2"
                        style={{
                          fontSize: '0.63rem',
                          fontWeight: 500,
                          lineHeight: '24px',
                          display: 'flex',
                          alignItems: 'center',
                        }}
                      >
                        {typeof tax?.TaxRate === 'number'
                          ? `${(tax.TaxRate * 100).toFixed(2)}%`
                          : `N/A`}
                      </Typography>
                    </Grid>
                    <Grid item xs={5}>
                      <Controller
                        name={`TaxAmtDetail[${index}]`}
                        control={control}
                        defaultValue={tax.TaxAmount}
                        render={({ onChange, value }) => (
                          <NumberFormat
                            customInput={TextField}
                            fullWidth
                            className="disabled-input"
                            thousandSeparator
                            decimalScale={2}
                            fixedDecimalScale
                            style={{
                              marginTop: '10px',
                              fontSize: '0.63rem',
                            }}
                            allowNegative={false}
                            // label="Tax Amount"
                            variant="outlined"
                            size="small"
                            value={
                              watch(`TaxAmtDetail[${index}]`) ?? tax.TaxAmount
                            }
                            onValueChange={({ floatValue }) => {
                              onChange(floatValue)
                              const allTaxDetails = watch('TaxAmtDetail') || []
                              allTaxDetails[index] = floatValue ?? 0
                              const total = allTaxDetails.reduce(
                                (acc, val) => acc + (parseFloat(val) || 0),
                                0
                              )
                              setValue('TaxAmt', total)
                            }}
                            InputProps={{
                              style: {
                                alignSelf: 'center',
                                fontSize: '0.63rem',
                                height: '23px',
                                width: '150px',
                                padding: '0 4px',
                                backgroundColor: '#ffffff',
                              },
                            }}
                            InputLabelProps={{ style: { display: 'none' } }}
                          />
                        )}
                      />
                    </Grid>
                  </Grid>
                ))}
              </Paper>
            </Grid>
          )}

          <Controller
            as={<NumberFormat allowNegative={false} />}
            thousandSeparator
            customInput={TextField}
            ref={register}
            control={control}
            margin="normal"
            name="TaxAmt"
            label="Tax Amount"
            disabled={formMode === 'approve-reject' ? true : false}
            onValueChange={e => {
              handleTaxAmtChange(e)
            }}
            decimalScale={2}
            fixedDecimalScale
            className="left"
            required
            InputProps={{
              disableUnderline: true,
              readOnly: true,
            }}
            defaultValue={PaymentItemID ? itemEditData?.TaxAmt : 0}
          />

          <TextField
            name="DocAmt"
            variant="outlined"
            label="Document Amount"
            value={amtNumStr(docAmt)}
            InputProps={{
              style: { color: '#96938e', backgroundColor: 'white' },
            }}
            className="outlined-disabled right"
            aria-disabled
            margin="normal"
            ref={register}
            style={{ marginTop: '25px', color: 'white' }}
            disabled
          />

          <VoiceTextField
            mounted={true}
            label="Remark"
            name="Remark"
            required
            value={voiceRemark}
            setValue={setValue}
            record={record}
            setRecord={setRecord}
            control={control}
            controllerProps={{
              error: errors?.Remark ? true : false,
              helperText: errors?.Remark?.message,
              ref: register,
              autoComplete: 'off',
            }}
          />

          {showExemptedFields && (
            <>
              <ItemVoiceTextField
                mounted={true}
                required
                label="Tax Exemption Reason"
                name="TaxExemptionReason"
                value={exemptionVoiceReason}
                setValue={setValue}
                record={exemptionRecord}
                setRecord={setExemptionRecord}
                control={control}
                controllerProps={{
                  error: errors?.TaxExemptionReason ? true : false,
                  defaultValue: itemEditData?.TaxExemptionReason,
                  helperText: errors?.TaxExemptionReason?.message,
                  ref: register,
                  autoComplete: 'off',
                }}
              />
              <TextField
                margin="dense"
                label="Exemptible Tax Amount"
                value={amtStr(taxExemptionData?.TaxExemptionAmount)}
                InputProps={{
                  readOnly: true,
                  disableUnderline: true,
                  endAdornment: (
                    <>
                      {awaitCalc ? (
                        <CircularProgress color="inherit" size={20} />
                      ) : null}
                    </>
                  ),
                }}
                className="left"
                disabled
              />
              {/* <TextField
                      margin="dense"
                      label="Exemptible Tax Rate"
                      value={`${amtStr(taxExemptionData?.TaxExemptionRate)}%`}
                      InputProps={{
                        readOnly: true,
                        disableUnderline: true,
                        endAdornment: (
                          <>
                            {awaitCalc ? (
                              <CircularProgress color="inherit" size={20} />
                            ) : null}
                          </>
                        ),
                      }}
                      className="right"
                      disabled
                    /> */}
            </>
          )}
        </CardContents>
      </ContentWrapper>

      <ErrorDialog
        errorDia={errorDia}
        setErrorDia={setErrorDia}
        errorMsg={errMsg}
        errorHeaderMsg={'Error!'}
      />

      <AccountFooter
        options={
          detailMode === 'edit'
            ? [
                {
                  name: 'Confirm',
                  color: 'primary',
                  onClick: () => {
                    handleSubmit(data =>
                      onSubmit(data, 'save', selectedTax, result)
                    )()
                  },
                  props: { type: 'submit' },
                },
              ]
            : [
                {
                  name: 'Confirm & New',
                  color: 'primary',
                  onClick: () => {
                    return new Promise<void>((resolve, reject) => {
                      handleSubmit(data => {
                        onSubmit(data, 'new', selectedTax, result)
                        resolve()
                      })()
                    }).then(() => {
                      handleReset()
                      setMountDefVal(false)
                      reset(defaultVal)
                      fetchDepartmentListingByCOA({
                        variables: { CompanyID },
                      })
                    })
                  },
                  props: {
                    type: 'submit',
                  },
                },
                {
                  name: 'Confirm',
                  color: 'primary',
                  onClick: () => {
                    handleSubmit(data =>
                      onSubmit(data, 'save', selectedTax, result)
                    )()
                  },
                  props: { type: 'submit' },
                },
              ]
        }
      />

      <ExitConfirmationDialog
        openExitConf={openExitConf}
        setOpenExitConf={setOpenExitConf}
        onConfirm={() => {
          if (formMode === 'add')
            history.push({
              pathname: `/cash-book/${CompanyID}/submenu/${BankAccountID}/payment/${formMode}`,
              state: { ...editData },
            })
          else {
            history.push({
              pathname: `/cash-book/${CompanyID}/submenu/${BankAccountID}/payment/${PaymentID}/${formMode}`,
              state: { ...editData, detailMode: 'add' },
            })
          }
        }}
      />
    </>
  )
}
function setErrDialog(arg0: boolean) {
  throw new Error('Function not implemented.')
}
